import { useDebouncedCallback } from "@tanstack/react-pacer";
import type { ShortCode, SubFamily } from "@/features/sub-families/types";
import type { WebComponentModeEnum } from "@/types";
import { useWebComponentHost } from "../providers/web-component-host.tsx";

const WAIT = 0;

export const EventNames = {
    SummaryActionClick: "summary-action-click",
    SmartNumberChange: "smart-number-change",
    SubFamilyChange: "sub-family-change",
} as const;

export type Events = {
    [EventNames.SummaryActionClick]: { smartNumber: string; shortCode: ShortCode | null; mode: WebComponentModeEnum };
    [EventNames.SmartNumberChange]: string;
    [EventNames.SubFamilyChange]: SubFamily;
};

export default function useEventEmitter<T extends keyof Events>(event: T) {
    const host = useWebComponentHost();

    return useDebouncedCallback(
        (data: Events[T]) => {
            host.dispatchEvent(
                new CustomEvent(event, {
                    bubbles: true, // Event leaves React tree and goes up
                    composed: true, // Event is allowed to escape the shadow DOM
                    detail: data,
                }),
            );
        },
        { wait: WAIT },
    );
}
